export const SIDE_LENGTH = 5;

export const INITIAL_MIN_CLUES = 8;
